module.exports = function (uniformFields, themeFieldsClasses) {
  return uniformFields.map(function (field) {
    field.themeClass = themeFieldsClasses[field.id]
    return field
  })
}
